import * as React from "react";
import { Text as MantineText } from "@mantine/core";
const Text = ({ ...props }) => /* @__PURE__ */ React.createElement(MantineText, { ...props });
export default Text;
